/**
 * Animation timing constants for consistent animations across the app
 * All values in milliseconds
 */

export const ANIMATION_DURATION = {
  // Panel transitions
  PANEL_TRANSITION: 280, // CSS width transition on side panel
  
  // Resize and layout
  RESIZE_DEBOUNCE: 150, // Shorter: RAF-throttle in useContainerSize is the real gate
  LAYOUT_RECALC_DEBOUNCE: 200,

  // Tile animations
  TILE_MOVE: 260, // A tile gliding to its new slot when the layout changes (TileLayer)
  TILE_ENTER: 320,
  TILE_EXIT: 200,
  
  // UI interactions
  TOOLTIP_DELAY: 500,
  HOVER_TRANSITION: 150,
  CLICK_FEEDBACK: 100,
  
  // Orientation change
  ORIENTATION_CHANGE_SUSPEND: 350,
} as const

export const ANIMATION_EASING = {
  EASE_OUT: 'cubic-bezier(0.2, 0, 0, 1)',
  EASE_IN_OUT: 'cubic-bezier(0.4, 0, 0.2, 1)',
  EASE_IN: 'cubic-bezier(0.4, 0, 1, 1)',
  SPRING: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
} as const

/**
 * GPU-accelerated animation properties
 */
export const GPU_ACCELERATED_PROPS = {
  willChange: 'transform',
  backfaceVisibility: 'hidden',
  WebkitBackfaceVisibility: 'hidden',
  transform: 'translateZ(0)',
} as const

/**
 * Layout containment for performance isolation
 */
export const LAYOUT_CONTAINMENT = {
  contain: 'layout style paint',
} as const
